<ng-container *ngIf="configuration$ | async as configuration; else spinner">
  <bw-contact-picker
    [config]="configuration"
    (value-changed)="onValueChange($event)"
  />
</ng-container>

<ng-template #spinner>
  <div class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
</ng-template>
